var map = {
	"./chocolate-fictional/recycling_end_of_life.json": [
		1924,
		[
			1924
		]
	],
	"./chocolate/recycling_end_of_life.json": [
		9760,
		[
			9760
		]
	],
	"./hemas-clogard/recycling_end_of_life.json": [
		2599,
		[
			2599
		]
	],
	"./linqOne/recycling_end_of_life.json": [
		2064,
		[
			2064
		]
	],
	"./munchee-tikiri-marie/recycling_end_of_life.json": [
		4055,
		[
			4055
		]
	],
	"./shan-teas/recycling_end_of_life.json": [
		662,
		[
			662
		]
	],
	"./wipotech-chocolates/recycling_end_of_life.json": [
		9305,
		[
			9305
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8473;
module.exports = webpackAsyncContext;